import { Controller } from "@hotwired/stimulus"

// Opens and closes a modal by element id.
//
// The id comes in as a value so more than one modal can use this controller;
// it defaults to the album modal, which was the only one when this was written.
export default class extends Controller {
  static values = { modalId: { type: String, default: "new-album-modal" } }

  open() {
    const modal = document.getElementById(this.modalIdValue)
    if (modal) {
      modal.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    }
  }

  close() {
    const modal = document.getElementById(this.modalIdValue)
    if (modal) {
      modal.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
